import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { DateRangeFilter, DateRangeTypeEnum, FilterItemList, PageTypeEnum } from '../models/filter.model';
import { EnumApprovalsTabs } from '../../models/approval.model';


@Injectable({
  providedIn: 'root'
})
export class ManipulationsToolbarService {

  // approvalsTab only matters when pageType is Approvals: the Reports tab shows its own filter set
  // (reportsFilterList) instead of the Pending/AfterApproval/DownloadRecords tabs' approvalsFilterList.
  getFilterItemList(pageType: PageTypeEnum, approvalsTab?: EnumApprovalsTabs): Observable<FilterItemList[]> {
    const questionnaireFilterList: FilterItemList[] =
      [
        {
          "id": 1,
          "displayNameHe": "יוצר השאלון",
          "displayNameEn": "Creator",
          "fieldName": "creator",
          "typeFilter": 1
        },
        {
          "id": 2,
          "displayNameEn": "Category",
          "displayNameHe": "קטגוריה",
          "fieldName": "categoryId",
          "typeFilter": 2
        },
        {
          "id": 3,
          "displayNameEn": "Distribution date",
          "displayNameHe": "תאריך הפצה",
          "fieldName": "distributionDate",
          "typeFilter": 5
        },
        {
          "id": 4,
          "displayNameEn": "Completion due date",
          "displayNameHe": "תאריך הגשה",
          "fieldName": "submissionDate",
          "typeFilter": 5
        },
        {
          "id": 5,
          "displayNameHe": "סטטוס",
          "displayNameEn": "Status",
          "fieldName": "status",
          "typeFilter": 2
        },
        {
          "id": 6,
          "displayNameHe": "סטטוס",
          "displayNameEn": "Status",
          "fieldName": "statusToUser",
          "typeFilter": 2
        },
      ];

    const remindersFilterList: FilterItemList[] =
      [
        {
          "id": 1,
          "displayNameEn": "Create Date",
          "displayNameHe": "תאריך יצירה",
          "fieldName": "createDate",
          "typeFilter": 5
        },
        {
          "id": 2,
          "displayNameEn": "Reminder Date",
          "displayNameHe": "תאריך תזכורת",
          "fieldName": "reminderDate",
          "typeFilter": 5
        },
        {
          "id": 3,
          "displayNameEn": "End date",
          "displayNameHe": "תאריך סיום",
          "fieldName": "endDate",
          "typeFilter": 5
        },
      ];

    const distributionGroupsFilterList: FilterItemList[] =
      [
        {
          "id": 1,
          "displayNameEn": "Create date",
          "displayNameHe": "תאריך יצירה",
          "fieldName": "createDate",
          "typeFilter": 5
        },
        {
          "id": 2,
          "displayNameHe": "מזהה יוצר הקבוצה",
          "displayNameEn": "Creator",
          "fieldName": "creator",
          "typeFilter": 1
        },
      ];

      const savedListFilterList: FilterItemList[] =
      [
        {
          "id": 1,
          "displayNameHe": "תאריך יצירה",
          "displayNameEn": "Create date",
          "fieldName": "createDate",
          "typeFilter": 5
        },
        {
          "id": 2,
          "displayNameHe": " יוצר הרשימה",
          "displayNameEn": "Creator",
          "fieldName": "creator",
          "typeFilter": 1
        },
      ];

       const approvalsFilterList: FilterItemList[] =
      [
        {
          "id": 1,
          "displayNameHe": "שם השולח",
          "displayNameEn": "Sending Name",
          "fieldName": "creator",
          "typeFilter": 2
        },
        {
          "id": 2,
          "displayNameHe": "סטטוס",
          "displayNameEn": "Status",
          "fieldName": "statusApproval",
          "typeFilter": 2
        },
      ];

    const payrollMonthsFilter: FilterItemList = {
      "id": 3,
      "displayNameHe": "חודש שכר",
      "displayNameEn": "Payroll month",
      "fieldName": "payrollMonths",
      "typeFilter": 4
    };

    const reportsFilterList: FilterItemList[] =
      [
        {
          "id": 1,
          "displayNameHe": "תאריך שליחה",
          "displayNameEn": "Send date",
          "fieldName": "createDate",
          "typeFilter": 5
        },
        {
          "id": 2,
          "displayNameHe": "שם שולח",
          "displayNameEn": "Sender name",
          "fieldName": "creator",
          "typeFilter": 2
        },
        {
          "id": 3,
          "displayNameHe": "מאשרים",
          "displayNameEn": "Approvers",
          "fieldName": "approverIds",
          "typeFilter": 3
        },
        {
          "id": 4,
          "displayNameHe": "מספר שאלון",
          "displayNameEn": "Questionnaire number",
          "fieldName": "questionnaireNumber",
          "typeFilter": 2
        },
        {
          "id": 5,
          "displayNameHe": "סטטוס טופס",
          "displayNameEn": "Form status",
          "fieldName": "formStatus",
          "typeFilter": 4
        },
        {
          "id": 6,
          "displayNameHe": "סטטוס ייצוא רשומה למלמ",
          "displayNameEn": "MLM export status",
          "fieldName": "mlmExportStatus",
          "typeFilter": 4
        },
        {
          "id": 9,
          "displayNameHe": "תאריך ייצוא למלמ",
          "displayNameEn": "MLM export date",
          "fieldName": "mlmLastExportDate",
          "typeFilter": 5
        },
        {
          "id": 10,
          "displayNameHe": "תאריך אישור טופס",
          "displayNameEn": "Form approval date",
          "fieldName": "formApprovalDate",
          "typeFilter": 5
        },
        {
          "id": 7,
          "displayNameHe": "סכום",
          "displayNameEn": "Amount",
          "fieldName": "amount",
          "typeFilter": 1
        },
        {
          "id": 8,
          "displayNameHe": "חיוב לקוח",
          "displayNameEn": "Client charge",
          "fieldName": "clientCharge",
          "typeFilter": 2
        },
      ];

    switch (pageType) {
      case PageTypeEnum.QuestionnairesList:
        return of(questionnaireFilterList);
      case PageTypeEnum.Reminders:
        return of(remindersFilterList);
      case PageTypeEnum.DistributionGroups:
        return of(distributionGroupsFilterList);
        case PageTypeEnum.SavedLists:
          return of(savedListFilterList);
        case PageTypeEnum.Approvals:
          if (approvalsTab === EnumApprovalsTabs.Reports)
            return of(reportsFilterList);
          // "חודש שכר" is meaningful only once a request is approved (it can then be exported to payroll).
          return of(approvalsTab === EnumApprovalsTabs.AfterApproval ? [...approvalsFilterList, payrollMonthsFilter] : approvalsFilterList);
    }

  }
  getDateRangeFilter() {
    const res: DateRangeFilter[] = [
      { key: DateRangeTypeEnum.Days7, valueHe: '7 ימים אחרונים', valueEn: 'Last 7 days' },
      { key: DateRangeTypeEnum.Month1, valueHe: 'חודש אחרון', valueEn: 'Last month' },
      { key: DateRangeTypeEnum.Month12, valueHe: '12 חודשים אחרונים', valueEn: 'Last 12 months' },
      {
        key: DateRangeTypeEnum.CurrentYear,
        valueHe: 'שנה נוכחית (' + new Date().getFullYear() + ')',
        valueEn: 'Current Year (' + new Date().getFullYear() + ')',
      },
      {
        key: DateRangeTypeEnum.LastYear,
        valueHe: 'שנה קודמת (' + (new Date().getFullYear() - 1) + ')',
        valueEn: 'Last year (' + (new Date().getFullYear() - 1) + ')',
      },
      { key: DateRangeTypeEnum.Custom, valueHe: 'טווח תאריכים', valueEn: 'Range of dates' },
    ];
    return of(res);
  }

}
